import React from 'react';

import useStyles from '../useStyles';
import styles from './styles';
import { Typography } from '@material-ui/core';

// TODO: Memorize component
const Logo = (props) => {
  const classes = useStyles(styles);
  const { className } = props;

  return (
    <div className={`${classes.container} ${className || ''}`}>
      <Typography className={classes.main} variant="h5" align="center">
        FARMERS CO-OPERATIVE
      </Typography>
      <Typography className={classes.second} variant="h6" align="center">
        INSURANCE COMPANY
      </Typography>
    </div>
  );
};
export default Logo;
